export default __webpack_public_path__ + "static/media/Politics.1228d9a7.svg";